import React from "react";
import {Button, Row, Col, Glyphicon} from "react-bootstrap";
import AscComponent from "../../components/AscComponent";
import CommonTable from "../../containers/Elements/Table/CommonTable";
import moment from "moment-timezone";
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import * as GlobalConst from "../../components/AscConstants";
import ControlLogModal from './ControlLogModal';
import _ from "lodash";
import ControlLogMenu from "./ControlLogMenu";
import styled from "@emotion/styled";
import * as faIcon from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SearchMenu = styled.div`
    width: ${(p) => p.width || 0}px;
    height: ${(p) => p.height || 0}px;
    position: fixed;
    right: 0;
    top: 90px;
    overflow-y: auto;
    display: flex;
    justify-content: center;

    transition: 0.5s;
    background-color: ${(p) => p.background || "#eef3f9"};
    box-shadow: 0px 0px 5px 0.1px rgba(172, 173, 168);
    border-radius: 4px;
    z-index: 1;
`;

export default class ControlLog extends AscComponent {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            pages: null,
            count: null,
            count_limit: 100000,
            loading: false,
            initialLoadComplete: false, // 初期ロード完了フラグ
            default_filtered: [
                {
                    id: "cm12_id",
                    value: {
                        value: this.props.userInfo.company_id, 
                        label:this.props.userInfo.company_name, 
                        floor_flg: (this.props.userInfo.floor_flg === true || this.props.userInfo.floor_flg === "Y") ? "Y" : "N"
                    }
                },
                {
                    id: "start_datetime",
                    value: moment({h:0, m:0, s:0, ms:0})
                },
                {
                    id: "end_datetime",
                    value: moment({h:0, m:0, s:0, ms:0})
                },
                {
                    id: "start_ji",
                    value: { value: '00', label: '00' },
                },
                {
                    id: "start_hun",
                    value: { value: '00', label: '00' },
                },
                {
                    id: "end_ji",
                    value: { value: '23', label: '23' },
                },
                {
                    id: "end_hun",
                    value: { value: '59', label: '59' },
                }
            ],
            filtered: [
                {
                    id: "cm12_id",
                    value: {
                        value: this.props.userInfo.company_id, 
                        label:this.props.userInfo.company_name, 
                        floor_flg: (this.props.userInfo.floor_flg === true || this.props.userInfo.floor_flg === "Y") ? "Y" : "N"
                    }
                },
                {
                    id: "start_datetime",
                    value: moment({h:0, m:0, s:0, ms:0})
                },
                {
                    id: "end_datetime",
                    value: moment({h:0, m:0, s:0, ms:0})
                },
                {
                    id: "start_ji",
                    value: { value: '00', label: '00' },
                },
                {
                    id: "start_hun",
                    value: { value: '00', label: '00' },
                },
                {
                    id: "end_ji",
                    value: { value: '23', label: '23' },
                },
                {
                    id: "end_hun",
                    value: { value: '59', label: '59' },
                }
            ],
            hidden_filtered: [
                {
                    id: "cm12_id",
                    value: {
                        value: this.props.userInfo.company_id, 
                        label:this.props.userInfo.company_name, 
                        floor_flg: (this.props.userInfo.floor_flg === true || this.props.userInfo.floor_flg === "Y") ? "Y" : "N"
                    }
                },
                {
                    id: "start_datetime",
                    value: moment({h:0, m:0, s:0, ms:0})
                },
                {
                    id: "end_datetime",
                    value: moment({h:0, m:0, s:0, ms:0})
                },
                {
                    id: "start_ji",
                    value: { value: '00', label: '00' },
                },
                {
                    id: "start_hun",
                    value: { value: '00', label: '00' },
                },
                {
                    id: "end_ji",
                    value: { value: '23', label: '23' },
                },
                {
                    id: "end_hun",
                    value: { value: '59', label: '59' },
                }
            ],
            companySelect: [],
            departmentSelect: [],
            floorSelect: [],
            executionUserSelect: [],
            menuNameSelect: [],
            executionDetailSelect: [],

            // modal item
            show: false,
            modalType: null,
            blocking: false,

            // メニュー
            menu_height: window.innerHeight - 105,
            menu_width: 0,
            menu_flag: false,

            // メニューデータ
            menuItems: [],
            // 実行内容データ
            executionDetails: {},
            // 会社オプションフラグ
            eval_flag: false
        };

        // クリア時に検索処理が実行されないようにするフラグ
        this.ignoreFetchData = false;
        this.hourShowList = this.getSelectOption('hour_show_list', this.props.langText.SelectOption);
        this.minuteShowList = this.getSelectOption('minute_show_list', this.props.langText.SelectOption);

        this.table = React.createRef();
    }

    async componentDidMount() {
        if (this.props.isAuthenticated) {
            await this.getMenuStructure();
            await this.getExecutionDetails();
            await this.getCompanyControlByCompanyId("CALL_EVAL", "CALL_EVAL_OPTION");
            await this.onSearch(this.state.filtered);
            await this.initializeSelectOptions();
            this.setState({ initialLoadComplete: true }); // 初期ロード完了フラグ設定
        }
    }

    // メニュー構造を取得
    getMenuStructure = async () => {
        try {
            const result = await this.ascAxios('post', '/Common/getSystemParameterJsonValue', {
                function_id: 'CONSTANT',
                parameter_id: 'CONTROL_LOG_MENU_STRUCTURE'
            });
            
            if (result.data) {
                this.setState({ menuItems: result.data });
            }
        } catch (err) {
            console.error('メニュー構造取得失敗:', err);
            // ロード失敗時は空配列を設定
            this.setState({ menuItems: [] });
        }
    }

    // 実行内容構造を取得
    getExecutionDetails = async () => {
        try {
            const result = await this.ascAxios('post', '/Common/getSystemParameterJsonValue', {
                function_id: 'CONSTANT',
                parameter_id: 'CONTROL_LOG_EXECUTION_DETAILS'
            });
            
            if (result.data) {
                this.setState({ executionDetails: result.data });
            }
        } catch (err) {
            console.error('実行内容構造取得失敗:', err);
            // ロード失敗時は空オブジェクトを設定
            this.setState({ executionDetails: {} });
        }
    }

    // 会社オプションチェック
    getCompanyControlByCompanyId = async (function_id, parameter_id) => {
        const company_id = this.props.userInfo.company_id;

        try {
            const result = await this.ascAxios('post', `${this.reactContainerPath}/getCompanyControlCallEvalByCompanyId`, {
                company_id,
                function_id,
                parameter_id
            });

            let flag = result.data && result.data.parameter_value === "Y" ? true : false;

            this.setState({
                eval_flag: flag
            });
        } catch (err) {
            console.error(err);
            this.setState({ eval_flag: false });
        }
    }

    // 権限に応じた選択肢の初期化
    initializeSelectOptions = async () => {
        try {
            // メニュー名・実行内容選択肢を初期化
            const menuNameItems = this.getMenuItems();
            
            let stateUpdate = {
                menuNameSelect: menuNameItems,
            };

            // システム管理者・OEM管理者の場合、会社選択肢設定
            if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)) {
                const res = await this.getCommonCompanySelect(this.reactContainerPath);
                stateUpdate.companySelect = res.data;
                
                // 既に選択されている会社の拠点選択肢も取得
                const selectedCompany = this.getFilterData("cm12_id");
                if (selectedCompany && selectedCompany.value) {
                    const departmentRes = await this.getCommonDepartmentSelect({
                        container: this.reactContainerPath,
                        company_id: selectedCompany.value,
                        floor_flg: (selectedCompany.floor_flg === "Y" || selectedCompany.floor_flg === true)
                    });
                    stateUpdate.departmentSelect = departmentRes.data;

                    // 実行ユーザー選択肢取得
                    const userRes = await this.getUserSelect({
                        cm12_id: selectedCompany.value
                    });
                    stateUpdate.executionUserSelect = userRes.data;
                }
                
                this.setState(stateUpdate);
            } else if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company)) {
                // 会社管理者の場合、拠点選択肢設定
                const res = await this.getCommonDepartmentSelect({
                    container: this.reactContainerPath,
                    company_id: this.props.userInfo.company_id,
                    floor_flg: (this.props.userInfo.floor_flg === "Y" || this.props.userInfo.floor_flg === true)
                });

                // 実行ユーザー選択肢取得
                const userRes = await this.getUserSelect({
                    cm12_id: this.props.userInfo.company_id
                });

                stateUpdate.departmentSelect = res.data;
                stateUpdate.executionUserSelect = userRes.data;
                
                this.setState(stateUpdate);
            } else if (
                // 拠点管理者でフロアがない場合
                this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.department) &&
                !this.props.userInfo.floor_flg
            ) {
                // 実行ユーザー選択肢取得
                const userRes = await this.getUserSelect({
                    cm13_id: this.props.userInfo.department_id
                });
                stateUpdate.executionUserSelect = userRes.data;
                
                this.setState(stateUpdate);
            } else if (
                // 拠点管理者でフロアがある場合、フロア選択肢設定
                this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.department) &&
                this.props.userInfo.floor_flg
            ) {
                const res = await this.getCommonFloorSelect({
                    departmentIds: this.props.userInfo.parent_department_id
                });

                // 実行ユーザー選択肢取得
                const userRes = await this.getUserSelect({
                    cm13_id: res.data.map(row => row.value)
                });

                stateUpdate.floorSelect = res.data;
                stateUpdate.executionUserSelect = userRes.data;
                
                this.setState(stateUpdate);
            } else if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.floor)) {
                // フロア管理者の場合
                const userRes = await this.getUserSelect({
                    floor_id: this.props.userInfo.department_id
                });
                stateUpdate.executionUserSelect = userRes.data;
                
                this.setState(stateUpdate);
            } else {
                // その他の場合もメニュー関連の選択肢は設定
                this.setState(stateUpdate);
            }
        } catch (err) {
            this.showErrorObjectMesssage(err, "DataSelectError");
        }
    }

    // 実行ユーザー選択肢取得
    getUserSelect = async (params) => {
        try {
            return await this.ascAxios('post', `${this.reactContainerPath}/getUserSelect`, params);
        } catch (err) {
            this.showErrorObjectMesssage(err, "DataSelectError");
            return { data: [] };
        }
    }

    // 拠点選択肢を非同期で読み込み
    loadDepartmentSelect = async (companyId, floorFlg) => {
        try {
            const res = await this.getCommonDepartmentSelect({
                container: this.reactContainerPath,
                company_id: companyId,
                floor_flg: floorFlg
            });
            this.setState({ departmentSelect: res.data });
        } catch (err) {
            this.showErrorObjectMesssage(err, "DataSelectError");
        }
    }

    // フロア選択肢を非同期で読み込み
    loadFloorSelect = async (departmentIds) => {
        try {
            const res = await this.getCommonFloorSelect({
                departmentIds: departmentIds
            });
            this.setState({ floorSelect: res.data });
        } catch (err) {
            this.showErrorObjectMesssage(err, "DataSelectError");
        }
    }

    // 実行ユーザー選択肢を非同期で読み込み
    loadExecutionUserSelect = async (params) => {
        try {
            // 拠点のみ選択 + 会社がフロア利用時は拠点配下の全フロアIDを展開して検索
            if (
                params &&
                params.cm13_id &&
                !Array.isArray(params.cm13_id) &&
                (params.floor_flg === 'Y' || params.floor_flg === true)
            ) {
                const res = await this.getCommonFloorSelect({
                    departmentIds: params.cm13_id
                });
                const floorIds = (res && res.data ? res.data : []).map(row => row.value);
                const userRes = await this.getUserSelect({
                    cm13_id: [params.cm13_id, ...floorIds]
                });
                this.setState({ executionUserSelect: userRes.data });
                return;
            }

            const userRes = await this.getUserSelect(params);
            this.setState({ executionUserSelect: userRes.data });
        } catch (err) {
            this.showErrorObjectMesssage(err, "DataSelectError");
        }
    }

    // アイコン付きメニューラベルを生成
    createMenuLabelWithIcon = (icon, text) => {
        return (
            <div className="menu-select-label-with-icon">
                <FontAwesomeIcon icon={icon} className="menu-select-icon" />
                <span>{text}</span>
            </div>
        );
    }

    // FontAwesome アイコンを動的に取得
    getIconFromKey = (iconKey) => {
        // faIconオブジェクトから動的にアイコンを取得
        return faIcon[iconKey] || faIcon.faDesktop;
    }

    // テキストキーを実際のテキストに変換
    getTextByKey = (langText, textKey) => {
        const keys = textKey.split('.');
        let result = langText;
        for (const key of keys) {
            result = result[key];
            if (!result) break;
        }
        return result || textKey;
    }

    // パネル別権限チェック関数
    checkPanelPermission = (panelValue, permissionList) => {
        switch (panelValue) {
            case 'Summary/MonitoringSummary':
                // モニタリング権限チェック
                const monitoringPermission = permissionList.find(
                    permission => permission.controller_id === "Monitoring"
                );
                return monitoringPermission && monitoringPermission.read;
                
            case 'Summary/CallAnalysisSummary':
                // システム権限または会社のeval_flagチェック
                const summaryPermission = permissionList.find(
                    permission => permission.controller_id === "Summary"
                );
                const hasSystemScope = summaryPermission && summaryPermission.scope_code === "system";
                // 会社オプションチェック（Summary.jsと同じ方式）
                return hasSystemScope || this.state.eval_flag;
                
            default:
                // 基本的にすべてのパネル許可（既存動作維持）
                return true;
        }
    }

    // メニューデータを処理
    getMenuItems = () => {
        const { langText, userInfo, systemParameters } = this.props;
        let returnValue = [];
        let permissionList = userInfo.permission_json_data;

        // DBロード失敗時は空配列を返す
        if (!this.state.menuItems || this.state.menuItems.length === 0) {
            return returnValue;
        }

        this.state.menuItems.forEach((menuItem) => {
            // 特殊ルール: CallHistoryAnalysis は個別権限なし
            // 条件: CallHistory 権限があり、かつ会社のCALL_EVALオプションがON
            const controllerId = menuItem.value.replace("/", "");
            if (controllerId === "CallHistoryAnalysis") {
                const hasCallHistoryPermission = permissionList.find(p => p.controller_id === "CallHistory" && p.read);
                const hasEvalOption = this.state.eval_flag === true;
                if (hasCallHistoryPermission && hasEvalOption) {
                    // 基本メニュー追加
                    returnValue.push({
                        value: menuItem.value,
                        label: this.createMenuLabelWithIcon(
                            this.getIconFromKey(menuItem.icon),
                            this.getTextByKey(langText, menuItem.text_key)
                        ),
                        level: 0
                    });
                    // パネルがあれば同様に追加（現状なしだが将来に備える）
                    if (menuItem.panels.length > 0) {
                        menuItem.panels.forEach(panel => {
                            const hasPanelPermission = this.checkPanelPermission(panel.value, permissionList);
                            if (hasPanelPermission) {
                                returnValue.push({
                                    value: panel.value,
                                    label: this.createMenuLabelWithIcon(
                                        this.getIconFromKey(menuItem.icon),
                                        this.getTextByKey(langText, panel.text_key)
                                    ),
                                    level: 1
                                });
                            }
                        });
                    }
                }
                return; // 特殊処理済み
            }
            for (let i = 0; i < permissionList.length; i++) {
                if (
                    permissionList[i].controller_id === menuItem.value.replace("/", "") &&
                    permissionList[i].read
                ) {
                    if (permissionList[i].controller_id !== "Floor") {
                        // 基本メニュー追加
                        returnValue.push({
                            value: menuItem.value,
                            label: this.createMenuLabelWithIcon(
                                this.getIconFromKey(menuItem.icon), 
                                this.getTextByKey(langText, menuItem.text_key)
                            ),
                            level: 0
                        });

                        if (menuItem.panels.length > 0) {
                            // パネルがある場合はパネルメニュー追加（権限チェック付き）
                            menuItem.panels.forEach(panel => {
                                // パネル別権限チェック（panel.value基準）
                                const hasPanelPermission = this.checkPanelPermission(panel.value, permissionList);
                                
                                // 権限がある場合のみパネルメニュー追加
                                if (hasPanelPermission) {
                                    returnValue.push({
                                        value: panel.value,
                                        label: this.createMenuLabelWithIcon(
                                            this.getIconFromKey(menuItem.icon), 
                                            this.getTextByKey(langText, panel.text_key)
                                        ),
                                        level: 1
                                    });
                                }
                            });
                        }
                    } else if (
                        permissionList[i].controller_id === "Floor" &&
                        (userInfo.floor_flg ||
                            (permissionList[i].scope_code === GlobalConst.SCOPE_OBJECT.system.name &&
                                systemParameters.SYSTEM_FLOOR_FLG === "Y"))
                    ) {
                        // フロア管理はフロアフラグTrueまたはシステム範囲権限を持ちSYSTEM_FLOOR_FLG=Yの時
                        returnValue.push({
                            value: menuItem.value,
                            label: this.createMenuLabelWithIcon(
                                this.getIconFromKey(menuItem.icon), 
                                this.getTextByKey(langText, menuItem.text_key)
                            ),
                            level: 0
                        });
                    }
                }
            }
        });

        return returnValue;
    }

    // 階層構造メニュー選択処理（ユーザーの意図を考慮）- 最適化済み
    processHierarchicalMenuSelection = (selectedMenus) => {
        const { menuNameSelect } = this.state;
        
        // 空配列またはメニューデータがない場合は早期リターン
        if (!selectedMenus || selectedMenus.length === 0 || !menuNameSelect || menuNameSelect.length === 0) {
            return selectedMenus || [];
        }
        
        let finalSelection = [...selectedMenus];
        let selectedValues = finalSelection.map(menu => menu.value);
        
        // 現在のフィルターから以前の選択状態を取得
        const previousMenuSelection = this.getFilterData("menu_name") || [];
        const previousValues = previousMenuSelection.map(menu => menu.value);
        
        // Setを使用してO(1)検索最適化（Array.includesの代わりに）
        const previousValueSet = new Set(previousValues);
        const selectedValueSet = new Set(selectedValues);
        
        // 追加・削除されたメニューを特定 - O(N) 複雑度
        const addedValues = selectedValues.filter(value => !previousValueSet.has(value));
        const removedValues = previousValues.filter(value => !selectedValueSet.has(value));
        
        // 初期ロードや変化がない場合でも階層構造を適用
        const shouldProcessHierarchy = addedValues.length > 0 || removedValues.length > 0 || previousValues.length === 0;
        
        if (shouldProcessHierarchy) {
            // 削除する値を集めて一度に処理 - 配列修正最適化（O(N²) → O(N)）
            const valuesToRemove = new Set();
            
            // 1. Level 0が削除された場合 → 該当するLevel 1も自動削除
            removedValues.forEach(removedValue => {
                const removedMenu = menuNameSelect.find(m => m.value === removedValue);
                if (removedMenu && removedMenu.level === 0) {
                    const childMenus = menuNameSelect.filter(menu => 
                        menu.level === 1 && 
                        menu.value.startsWith(removedValue + '/')
                    );
                    
                    childMenus.forEach(childMenu => {
                        if (selectedValueSet.has(childMenu.value)) {
                            valuesToRemove.add(childMenu.value);
                        }
                    });
                }
            });
            
            // 2. Level 1が削除された場合 → 該当するLevel 0も無条件削除
            removedValues.forEach(removedValue => {
                const removedMenu = menuNameSelect.find(m => m.value === removedValue);
                if (removedMenu && removedMenu.level === 1) {
                    const parentValue = removedValue.split('/')[0];
                    const parentMenu = menuNameSelect.find(menu => 
                        menu.value === parentValue && menu.level === 0
                    );
                    
                    if (parentMenu && selectedValueSet.has(parentValue)) {
                        valuesToRemove.add(parentValue);
                    }
                }
            });
            
            // 3. すべてのLevel 0に対して下位が完全でなければ削除（追加保証）
            const currentLevel0Values = selectedValues.filter(value => {
                const menu = menuNameSelect.find(m => m.value === value);
                return menu && menu.level === 0;
            });
            
            currentLevel0Values.forEach(level0Value => {
                const allChildMenus = menuNameSelect.filter(menu => 
                    menu.level === 1 && 
                    menu.value.startsWith(level0Value + '/')
                );
                
                const selectedChildMenus = allChildMenus.filter(childMenu => 
                    selectedValueSet.has(childMenu.value)
                );
                
                // すべての下位が選択されていなければLevel 0削除
                if (allChildMenus.length > 0 && selectedChildMenus.length < allChildMenus.length) {
                    valuesToRemove.add(level0Value);
                }
            });
            
            // 一度にすべての削除処理 - filter一回のみ実行して性能向上
            if (valuesToRemove.size > 0) {
                finalSelection = finalSelection.filter(menu => !valuesToRemove.has(menu.value));
                selectedValues = selectedValues.filter(value => !valuesToRemove.has(value));
                valuesToRemove.forEach(value => selectedValueSet.delete(value));
            }
            
            // Level 0が追加された場合のみ → 該当するLevel 1も自動追加（削除中は実行しない）
            if (addedValues.length > 0 && removedValues.length === 0) {
                addedValues.forEach(addedValue => {
                    const menu = menuNameSelect.find(m => m.value === addedValue);
                    if (menu && menu.level === 0) {
                        const childMenus = menuNameSelect.filter(menu => 
                            menu.level === 1 && 
                            menu.value.startsWith(addedValue + '/')
                        );
            
                        childMenus.forEach(childMenu => {
                            if (!selectedValueSet.has(childMenu.value)) {
                                finalSelection.push(childMenu);
                                selectedValues.push(childMenu.value);
                                selectedValueSet.add(childMenu.value);
                            }
                        });
                    }
                });
            }
        
            // Level 1がすべて選択された場合 → 該当するLevel 0も自動追加
            const allLevel0Menus = menuNameSelect.filter(menu => menu.level === 0);
            allLevel0Menus.forEach(parentMenu => {
                // 既に選択されている場合はスキップ
                if (selectedValueSet.has(parentMenu.value)) return;
                
                const childMenus = menuNameSelect.filter(menu => 
                    menu.level === 1 && 
                    menu.value.startsWith(parentMenu.value + '/')
                );
                
                    // 子要素があり、すべての子要素が選択されている場合
                if (childMenus.length > 0) {
                    const allChildrenSelected = childMenus.every(childMenu => 
                        selectedValueSet.has(childMenu.value)
                    );
                    
                    if (allChildrenSelected) {
                        finalSelection.push(parentMenu);
                        selectedValues.push(parentMenu.value);
                        selectedValueSet.add(parentMenu.value);
                    }
                }
            });
        }
        
        return finalSelection;
    }

    // メニューデータから表示名を変換
    convertMenuValueToDisplayName = (menuValue) => {
        const { langText } = this.props;

        // DBロード失敗時は入力値をそのまま返す
        if (!menuValue || !this.state.menuItems || this.state.menuItems.length === 0) {
            return menuValue;
        }

        // パネルがある場合まず確認（URLにパネルパスが含まれているかチェック）
        for (const menuItem of this.state.menuItems) {
            if (menuItem.panels && menuItem.panels.length > 0) {
                const foundPanel = menuItem.panels.find(panel => menuValue.startsWith(panel.value));
                if (foundPanel) {
                    return `${this.getTextByKey(langText, menuItem.text_key)}/${this.getTextByKey(langText, foundPanel.text_key)}`;
                }
            }
        }

        // 基本メニューから検索（URLにメニューパスが含まれているかチェック）
        const matchedMenus = this.state.menuItems.filter(item => menuValue.startsWith(item.value));

        // 候補がなければそのまま返す
        if (!matchedMenus || matchedMenus.length === 0) {
            return menuValue;
        }

        // value が長い順に並べて、最初のものを採用
        matchedMenus.sort((a, b) => b.value.length - a.value.length);
        const foundMenu = matchedMenus[0];

        return this.getTextByKey(langText, foundMenu.text_key);

    }

    // 実行内容データから表示名を変換
    convertExecutionDetailToDisplayName = (resource) => {
        // DBロード失敗時や値が空の場合は入力値をそのまま返す
        if (!resource || !this.state.executionDetails) {
            return resource;
        }

        // まず該当resourceからメニュー部分を検索
        let menuPath = null;
        let executionDetailValue = null;

        // 実行内容構造からマッチするメニューパスを検索
        const executionDetailKeys = Object.keys(this.state.executionDetails);
        for (const key of executionDetailKeys) {
            if (resource.startsWith(key + '/')) {
                menuPath = key;
                executionDetailValue = resource.substring(key.length + 1);
                break;
            }
        }

        // メニューパスが見つからない、または実行内容がない場合
        if (!menuPath || !executionDetailValue) {
            return resource;
        }

        // 該当メニューの実行内容リストを取得
        const executionDetailList = this.state.executionDetails[menuPath];
        if (!executionDetailList || !Array.isArray(executionDetailList)) {
            return executionDetailValue;
        }

        // 1) 完全一致を最優先
        let foundItem = executionDetailList.find(item => item.value === executionDetailValue);
        if (foundItem) return foundItem.label;

        // 2) 末尾一致候補のうち、valueが最も長い(=より具体的)ものを優先
        const candidates = executionDetailList
            .filter(item => executionDetailValue.endsWith(item.value))
            .sort((a, b) => (b.value ? b.value.length : 0) - (a.value ? a.value.length : 0));
        foundItem = candidates[0];
        return foundItem ? foundItem.label : executionDetailValue;
    }



    // メニュー別実行内容アイテムを取得
    getExecutionDetailByMenu = (menuValue) => {
        if (!menuValue) return [];
        
        // DBから取得した実行内容を使用
        const { executionDetails } = this.state;
        
        // 完全一致での検索
        return executionDetails[menuValue] || [];
    }

    getColumnsData() {
        const { 
            langText, 
            boardWidth, 
            userInfo 
        } = this.props;
        let columns = [];
        
        // ID
        columns.push({
            Header: langText.Body.Id,
            sortable: false,
            accessor: "id",
            width: boardWidth.small
        });
        
        // 会社名 - ORM管理者以上のみ表示
        if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)) {
            columns.push({
                Header: langText.Body.CompanyName,
                sortable: false,
                accessor: "company_name",
            });
        }
        
        // 拠点名 - 会社管理者以上のみ表示
        if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company)) {
            columns.push({
                Header: langText.Body.DepartmentName,
                sortable: false,
                accessor: "department_name",
            });
        }
        
        // フロア - 拠点管理者以上 + floor_flg
        const shouldShowFloor = this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.system) 
            ? this.getHiddenFilterCompanyFloorFlg() 
            : (userInfo && (userInfo.floor_flg === true || userInfo.floor_flg === "Y") && this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.department));
        
        if (shouldShowFloor) {
            columns.push({
                Header: langText.Body.FloorName,
                sortable: false,
                accessor: "floor_name",
            });
        }
        
        // 実行ユーザー
        columns.push({
            Header: langText.Body.ExecUser,
            sortable: false,
            accessor: "exec_user",
            width: boardWidth.large
        });
        
        // 実行日時
        columns.push({
            Header: langText.Body.ExecTime,
            accessor: "created",
            width: boardWidth.large,
            Cell: data => {
                return data.value ? this.getMomentTime({date: data.value, format: "YYYY/MM/DD HH:mm:ss"}) : "";
            }
        });
        
        // メニュー名
        columns.push({
            Header: langText.Body.MenuName,
            sortable: false,
            accessor: "menu_name",
            width: boardWidth.large
        });
        
        // 実行内容
        columns.push({
            Header: langText.Body.ExecutionDetail,
            sortable: false,
            accessor: "execution_detail",
            width: boardWidth.medium
        });

        // 操作
        columns.push({
            Header: langText.Body.Control,
            width: boardWidth.xsmall,
            sortable: false,
            Cell: data => {
                return(
                    <Row className="text-center">
                        <Button
                            key = {1}
                            bsSize="xsmall"
                            onClick={this.modalShow(data.row._original.id)}
                            className="control-button"
                        >
                            <Glyphicon glyph="eye-open"/>
                        </Button>
                    </Row>
                )
            }
        })

        return columns;
    }

    getFilterData = (param) => {
        let my_param_data = this.state.filtered.find(row => row.id === param);
        return my_param_data ? my_param_data.value : "";
    }

    // フィルター配列を指定して値を取得（setState前の暫定配列にも対応）
    getFilterDataFrom = (filteredArray, param) => {
        const found = (filteredArray || []).find(row => row.id === param);
        return found ? found.value : "";
    }

    // 選択された会社のfloor_flg取得
    getSelectedCompanyFloorFlg = () => {
        const selectedCompany = this.getFilterData("cm12_id");
        return selectedCompany && (selectedCompany.floor_flg === "Y" || selectedCompany.floor_flg === true);
    }

    // 検索実行済み会社のfloor_flg取得
    getHiddenFilterCompanyFloorFlg = () => {
        const hiddenCompany = this.state.hidden_filtered.find(row => row.id === "cm12_id");
        return hiddenCompany && hiddenCompany.value && (hiddenCompany.value.floor_flg === "Y" || hiddenCompany.value.floor_flg === true);
    }

    onChange = (event, param) => {
        let my_filtered = [...this.state.filtered],
            target_index = my_filtered.findIndex(row => row.id === param),
            value = "";
        
        if (event) {
            value = event.target ? event.target.value : event;
        }
        
        if (target_index !== -1) {
            my_filtered.splice(target_index, 1);
        }

        if (value && (!Array.isArray(value) || value.length)) {
            my_filtered.push({
                id: param,
                value
            });
        }

        // 会社選択状態のフロア利用フラグを一度だけ算出して再利用
        const companyForFlag = param === "cm12_id" ? value : this.getFilterData("cm12_id");
        const isFloorCompany = companyForFlag && (companyForFlag.floor_flg === "Y" || companyForFlag.floor_flg === true);

        // 会社選択時の処理
        if (param === "cm12_id" && event && event.value) {
            // 下位選択された値もクリア
            my_filtered = my_filtered.filter(item => 
                item.id !== "cm13_id" && 
                item.id !== "floor_id" && 
                item.id !== "execution_user"
            );

            this.setState({
                departmentSelect: [],
                floorSelect: [],
                executionUserSelect: []
            });

            this.loadDepartmentSelect(event.value, (event.floor_flg === "Y" || event.floor_flg === true));
            this.loadExecutionUserSelect({ cm12_id: event.value });
        }

        // 拠点選択時の処理
        if (param === "cm13_id" && event && event.value) {
            // 下位選択された値もクリア
            my_filtered = my_filtered.filter(item => 
                item.id !== "floor_id" && 
                item.id !== "execution_user"
            );

            this.setState({
                floorSelect: [],
                executionUserSelect: []
            });

            // 選択された会社のフロアフラグ確認
            if (isFloorCompany) {
                // フロアがある場合、フロア選択肢取得
                this.loadFloorSelect(event.value);
            }

            // 実行ユーザー選択肢取得 (会社がフロア利用なら配下フロアも展開)
            this.loadExecutionUserSelect({
                cm13_id: event.value,
                floor_flg: isFloorCompany
            });
        } else if (param === "cm13_id") {
            // 拠点クリア時 - 会社ユーザーに戻す
            // 下位選択された値もクリア
            my_filtered = my_filtered.filter(item => 
                item.id !== "floor_id" && 
                item.id !== "execution_user"
            );

            this.setState({
                floorSelect: [],
                executionUserSelect: []
            });

            const selectedCompany = this.getFilterData("cm12_id");
            if (selectedCompany && selectedCompany.value) {
                this.loadExecutionUserSelect({ cm12_id: selectedCompany.value });
            }
        }

        // フロア選択時の処理
        if (param === "floor_id" && event && event.value) {
            // 実行ユーザー選択された値をクリア
            my_filtered = my_filtered.filter(item => 
                item.id !== "execution_user"
            );

            this.setState({
                executionUserSelect: []
            });

            // 実行ユーザー選択肢取得
            this.loadExecutionUserSelect({ floor_id: event.value });
        } else if (param === "floor_id") {
            // フロアクリア時の処理
            // 実行ユーザー選択された値をクリア
            my_filtered = my_filtered.filter(item => 
                item.id !== "execution_user"
            );

            this.setState({
                executionUserSelect: []
            });

            // 拠点の実行ユーザーに戻す（会社がフロア利用なら配下フロアも展開）
            const selectedDepartment = this.getFilterData("cm13_id");
            if (selectedDepartment && selectedDepartment.value) {
                this.loadExecutionUserSelect({
                    cm13_id: selectedDepartment.value,
                    floor_flg: isFloorCompany
                });
            }
        }

        // メニュー名選択時の処理
        if (param === "menu_name" && event && event.length > 0) {
            // 階層構造処理を適用した最終選択リスト
            const processedMenuSelection = this.processHierarchicalMenuSelection(event);
            
            // 実際の値を更新
            const processedValue = processedMenuSelection.length > 0 ? processedMenuSelection : [];
            
            // フィルター配列から既存のmenu_nameを削除
            my_filtered = my_filtered.filter(item => item.id !== "menu_name");
            
            // 新しい値がある場合のみ追加
            if (processedValue.length > 0) {
                my_filtered.push({
                    id: "menu_name",
                    value: processedValue
                });
            }

            // 実行内容選択された値をクリア
            my_filtered = my_filtered.filter(item => 
                item.id !== "execution_detail"
            );

            // 選択されたメニューに応じた実行内容を取得（複数のメニューから結合）
            let allExecutionDetailItems = [];
            processedValue.forEach(selectedMenu => {
                const menuValue = selectedMenu.value;
                const executionDetailItems = this.getExecutionDetailByMenu(menuValue);
                allExecutionDetailItems = [...allExecutionDetailItems, ...executionDetailItems];
            });
            
            // 重複除去
            const uniqueExecutionDetails = allExecutionDetailItems.filter((item, index, self) => 
                self.findIndex(t => t.value === item.value) === index
            );
            
            this.setState({
                executionDetailSelect: uniqueExecutionDetails
            });
        } else if (param === "menu_name") {
            // メニュー名クリア時の処理
            // 実行内容選択された値をクリア
            my_filtered = my_filtered.filter(item => 
                item.id !== "execution_detail"
            );

            // 実行内容リストもクリア
            this.setState({
                executionDetailSelect: []
            });
        }

        let returnValue = [];
        returnValue = my_filtered;

        this.setState({
            filtered: returnValue
        }, () => {
            this.getValidationCheck();
        });
    }

    // 会社や集計期間未選択時、検索できないようにする
    getValidationCheck = () =>{
        let message = "";
        const filtered = this.state.filtered;

        const getVal = (key) => this.getFilterDataFrom(filtered, key);
        const startDate = getVal("start_datetime");
        const endDate = getVal("end_datetime");
        const startJi = (getVal("start_ji") && getVal("start_ji").value) || '00';
        const startHun = (getVal("start_hun") && getVal("start_hun").value) || '00';
        const endJi = (getVal("end_ji") && getVal("end_ji").value) || '23';
        const endHun = (getVal("end_hun") && getVal("end_hun").value) || '59';
        const company = getVal("cm12_id");
        
        if (!startDate || !endDate) {
            message = this.props.langText.Message.ControlLog_FindDataError;
            this.setState({searchValidation : true, message});
        } else if (moment.duration(moment(endDate).diff(moment(startDate))).asDays()<0){
            message = this.props.langText.Message.CallHistory_DayTermError;
            this.setState({searchValidation : true, message});
        } else if (moment(endDate).isSameOrAfter(moment(startDate).clone().add(1, 'month'))){
            message = this.props.langText.Message.GreaterThanOneMonthError;
            this.setState({searchValidation : true, message});
        } else if (!company) {
            this.setState({searchValidation : true});
        } else if (!this.setTimeCheck(
            startDate,
            endDate,
            startJi,
            startHun,
            endJi,
            endHun
        )) {
            message = this.props.langText.Message.StartDateTimeCheckError;
            this.setState({searchValidation : true, message});
        } else {
            this.setState({searchValidation: false, message: ""});
        }
    }

    setTimeCheck = (start_datetime, end_datetime, start_ji, start_hun, end_ji, end_hun) => {
        let flag = true;

        if (start_datetime && end_datetime && moment(start_datetime).format("YYYYMMDD") === moment(end_datetime).format("YYYYMMDD")){
            const sJi = parseInt(start_ji, 10);
            const eJi = parseInt(end_ji, 10);
            const sHun = parseInt(start_hun, 10);
            const eHun = parseInt(end_hun, 10);
            if (sJi > eJi) {
                flag = false;
            } else if (sJi === eJi && (sHun > eHun)) {
                flag = false;
            }
        }
        
        return flag;
    }

    onSearch = async(filter, tableState = null) => {
        try {
            this.setState({loading: true});
            
            // 検索ボタンクリック時のテーブル状態設定
            const currentState = this.table.current && this.table.current.state;
            const searchTableState = {
                page: 0, // 検索時は必ず1ページ目から
                pageSize: (currentState && currentState.pageSize) || 50, // 現在設定されたページサイズ維持
                sorted: [{id: "created", desc: true}] // ソートは初期化
            };
            
            // 検索実行
            await this.execFullTextSearch(
                filter,
                this.formatForTableDisplay,
                searchTableState
            );

            let hidden_filter = [];
            filter.forEach((row) => {
                hidden_filter.push(row);
            });

            this.setState({ 
                hidden_filtered: hidden_filter
            });
        } catch (err) {
            console.error(err);
            return this.showErrorObjectMesssage(err, "DataSelectError");
        }
    }

    /**
     * 全文検索実行
     * @param {Array} filter
     * @param {Function} formatCallback
     * @param {Object} state
     */
    execFullTextSearch = async (filter, formatCallback, state = null) => {
        try {
            this.setState({ loading: true });

            // 検索条件パラメータ設定
            const searchParams = {
                filter: filter,
                sorted: state && state.sorted && state.sorted.length > 0 ? state.sorted[0] : {},
                page: state ? state.page : 0,
                pageSize: state ? state.pageSize : 50
            };
            this.table.current.state.page = searchParams.page;

            // 全文検索実行
            const result = await this.ascAxios('post', `${this.reactContainerPath}/board`, searchParams);
            
            // 結果フォーマット
            const formattedData = formatCallback ? formatCallback(result.data.data) : result.data.data;

            this.setState({
                data: formattedData,
                count: result.data.count,
                pages: result.data.pages,
                loading: false
            });
        } catch (err) {
            console.error(err);
            this.setState({
                data: [],
                pages: null,
                count: null,
                loading: false
            });
            return this.showErrorObjectMesssage(err, "DataSelectError");
        }
    }

        /**
     * OpenSearch Raw結果をグリッド表示形式に整形
     * @param {Array} openSearchHits - OpenSearch hits.hits配列
     * @return {Array}
     */
    formatForTableDisplay = (openSearchHits) => {
        const tableDisplayData = [];
        if (openSearchHits && Array.isArray(openSearchHits)) {
            openSearchHits.forEach(hit => {
                // OpenSearch結果は_source内に実際のデータが格納されている
                const source = hit._source || {};
                
                tableDisplayData.push({
                    id: hit._id,
                    company_name: source.company_name,
                    department_name: source.department_name,
                    floor_name: source.floor_name,
                    exec_user: source.entry_user_name,
                    created: source.created,
                    menu_name: this.convertMenuValueToDisplayName(source.resource), 
                    execution_detail: this.convertExecutionDetailToDisplayName(source.resource)
                });
            });
        }
        return tableDisplayData;
    }

    // モーダル開く時モーダル内の情報取得
    getModalInfo(id) {
        return this.ascAxios('post', `${this.reactContainerPath}/modal`, { id });
    }

    modalShow = (id, modalType="controlLogDetail") => async event => {
        event.preventDefault();

        try {
            let setData = {
                show: true,
                modalType
            };

            switch (modalType) {
                case "controlLogDetail":
                    // 現在の行データから基本情報取得
                    const currentRowData = this.state.data.find(row => row.id === id);
                    let selected = currentRowData ? { ...currentRowData } : {};
                    
                    if (id) {
                        let res = await this.getModalInfo(id);
                        const data = res.data;
                        
                        selected = {
                            ...selected,
                            entry_user_email: data.entry_user_email,
                            client_ip: data.client_ip,
                            platform: data.platform,
                            browser: data.browser,
                            http_method: data.http_method,
                            status: data.status,
                            request_body: data.request_body,
                            resource: data.resource
                        };
                    }
        
                    setData = {
                        ...setData,
                        selected
                    }
                    break;
                default:
                    break;
            }
            
            this.setState(setData);
        } catch (err) {
            console.error(err);
            this.showErrorObjectMesssage(err, "DataSelectError");
        }
    }

    closeModal = () => {
        this.setState({show: false});
    }

    getModalBranch = () => {
        switch (this.state.modalType) {
            case "controlLogDetail":
                return (
                    <ControlLogModal
                        userInfo = {this.props.userInfo}
                        state = {this.state}
                        propSetState = {this.propSetState}
                        langText = {this.props.langText}
                        charaLimit = {this.props.charaLimit}
                        boardWidth = {this.props.boardWidth}
                        closeModal = {this.closeModal}
                        currentPermission = {this.props.currentPermission}
                        getMomentTime = {this.getMomentTime}
                    />
                );
        
            default:
                break;
        }
    }

    clearSearchCondition = async () => {
        let filter = _.cloneDeep(this.state.default_filtered);
        let hidden_filter = _.cloneDeep(this.state.default_filtered);
        
        // fetchDataが実行されないようにする
        this.ignoreFetchData = true;

        this.setState({
            filtered: filter,
            hidden_filtered: hidden_filter,
            // クリア時に依存セレクトも初期化
            departmentSelect: [],
            floorSelect: [],
            executionUserSelect: [],
            executionDetailSelect: []
        }, () => {
            // クリア後にバリデーションチェック実行
            this.getValidationCheck();
            // 権限とデフォルト会社に基づき各選択肢を再構築
            this.initializeSelectOptions();
        })

        // クリア終了したので実行されるように設定
        this.ignoreFetchData = false;
    }

    // メニューのサイズを調整
    resizeHandle = () => {
        let {
            menu_flag
        } = this.state;

        let height = window.innerHeight - 105;
        let width = 0;

        if (menu_flag) width = 400;

        this.setState({
            menu_height: height,
            menu_width: width
        });
    }

    // メニュー閉じる開く
    menuHandle = () => {
        this.setState({
            menu_flag: !this.state.menu_flag
        }, () => {
            this.resizeHandle();
        });
    }

    render() {
        return(
            <BlockUi tag="div" blocking={this.state.blocking} message={this.props.langText.Body.Wait} keepInView>
                <div className="ControlLog">
                    <Row>
                        <Col xs={12} md={12} className="margin-top-03 flex-style">
                            <Col sm={12} md={4} lg={2} className="search-count">
                                {
                                    (this.state.count || 0) <= this.state.count_limit &&
                                    <label>{this.props.langText.Body.SearchResult}</label>
                                }
                                {
                                    (this.state.count || 0) > this.state.count_limit 
                                        ? <>
                                            <label>{this.props.langText.Body.SearchResult}</label>
                                            <label className="result-count-limit">{this.state.count_limit.toLocaleString()}+{this.props.langText.Body.Count}</label>
                                        </>
                                        : <label className="result-count">{(this.state.count || 0).toLocaleString()}{this.props.langText.Body.Count}</label>
                                }
                            </Col>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} className="margin-top-05">
                            <CommonTable
                                tableState = {this.state}
                                propSetState = {this.propSetState}
                                talbeRef={this.table}
                                style={{ height: this.props.tableHeight + 10 }}
                                manual="manual"
                                columns = {this.getColumnsData()}
                                data={this.state.data}
                                pages={this.state.pages}
                                loading={this.state.loading}
                                defaultSorted={[{id: "created", desc: true}]}
                                defaultPageSize={50}
                                pageSizeOptions={[50, 100]}
                                onFetchData={async (state) => {
                                    if (this.ignoreFetchData || !this.state.initialLoadComplete) return;
                                    
                                    // テーブル操作（ページング、ソート等）時は直接execFullTextSearchを呼び出し
                                    await this.execFullTextSearch(
                                        this.state.filtered,
                                        this.formatForTableDisplay,
                                        state
                                    );
                                }}
                                hidden_filtered={this.state.hidden_filtered}
                                previousText={this.props.langText.Table.PreviousText}
                                nextText={this.props.langText.Table.NextText}
                                loadingText={this.props.langText.Table.LoadingText}
                                noDataText={this.props.langText.Table.NoDataText}
                                rowsText={this.props.langText.Table.RowsText}/>
                        </Col>
                    </Row>
                    {this.getModalBranch()}
                </div>
                <Col xs={0} sm={0}>
                    <SearchMenu
                        width={this.state.menu_width}
                        height={this.state.menu_height}
                    >
                        <ControlLogMenu
                            state={this.state}
                            userInfo={this.props.userInfo}
                            langText={this.props.langText}
                            getFilterData={this.getFilterData}
                            onChange={this.onChange}
                            onSearch={this.onSearch}
                            onClear={this.clearSearchCondition}
                            getScopeGreaterEqual={this.getScopeGreaterEqual}
                            hourShowList={this.hourShowList}
                            minuteShowList={this.minuteShowList}
                            propSetState={this.propSetState}
                            menuNameSelect={this.state.menuNameSelect}
                            executionDetailSelect={this.state.executionDetailSelect}
                            getSelectedCompanyFloorFlg={this.getSelectedCompanyFloorFlg}
                        />
                    </SearchMenu>
                </Col>
                <div className="search-menu-div">
                    <Button
                        className={`search-menu-button ${this.state.menu_flag ? "open" : ""}`}
                        onClick={() => this.menuHandle()}
                    >
                        {
                            this.state.menu_flag
                            ? this.props.langText.Body.Quotation
                            : this.props.langText.Body.LessThan
                        }
                    </Button>
                </div>
            </BlockUi>
        );
    }
} 